const IdmeStyles = {
    baseStyle: {
        button: {
            color: 'black.100',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: '300',
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
            marginTop: '30px',
            marginBottom: '14px'
        },
        drawerContent: {
            padding: '40px 20px 30px',
            borderRadius: '20px 20px 0px 0px'
        }
    }
}

export default IdmeStyles
